<template>
    <div class="export-btn" style="min-width: 160px;">
       <span class="headline min-width-btn">
          <i class="fal fa-file-pdf fa-xs" @click="exportPDF" style="cursor: pointer;" v-if="pdfLoading == false"></i>
          <i class="fas fa-circle-notch fa-spin" v-if="pdfLoading"></i>
        </span>
       <span class="headline min-width-btn">
          <i class="fal fa-map-marker-alt fa-xs" @click="downloadReportByRegionExcel" style="cursor: pointer;" v-if="reportByRegionLoading == false"></i>
          <i class="fas fa-circle-notch fa-spin" v-if="reportByRegionLoading"></i>
        </span>
        <span class="headline min-width-btn">
          <i class="fal fa-file-spreadsheet fa-xs" @click="exportExcel" style="cursor: pointer;" v-if="excelLoading == false"></i>
          <i class="fas fa-circle-notch fa-spin" v-if="excelLoading"></i>
        </span>
        <span class="headline min-width-btn" v-if="componentName == 'comptage'">
          <i class="fal fa-edit fa-xs" title="Éditer" @click="updateSearch" style="cursor: pointer;"></i>
        </span>
        <span class="headline min-width-btn" v-if="componentName == 'comptage'">
          <i class="fal fa-copy fa-xs" title="Copier" @click="copySearch" style="cursor: pointer;"></i>
        </span>
        <span class="headline min-width-btn" v-if="componentName == 'comptage'" style="cursor: pointer;">
          <i class="fal fa-trash-alt fa-xs" title="Supprimer" @click="deleteInvoice"></i>
        </span>
    </div>
</template>

<script>
  import SearchService from '@/services/search.service.js';
  import DatabaseService from '@/services/database.service.js';
  import InvoiceService from "@/services/invoice.service";
  import QuotationService from '@/services/quotation.service';

  export default {
    name: 'ExportData',
    data: () => ({
      pdfLoading: false,
      reportByRegionLoading: false,
      excelLoading: false
    }),
    props: {
      invoiceId: {
        type: Number,
        default: 0
      },
      componentName: {
        type: String,
        default: null,
      },
    },
    methods: {
      async exportPDF() {
        this.pdfLoading = true;

        const {data, fileName} = await InvoiceService.downloadPdf(this.invoiceId);

        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();

        this.pdfLoading = false;
      },
      async downloadReportByRegionExcel() {
        this.reportByRegionLoading = true;

        const {data, fileName} = await InvoiceService.downloadReportByRegionExcel(this.invoiceId);

        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();

        this.reportByRegionLoading = false;
      },
      async exportExcel() {
        this.excelLoading = true;

        const {data, fileName} = await DatabaseService.downloadExcel(this.invoiceId);

        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();

        this.excelLoading = false;
      },
      updateSearch(){
          this.$router.push({ name: 'search.index' , params: { invoiceId: this.invoiceId, task: 'editer' }})
      },
      copySearch(){
          this.$router.push({ name: 'search.index' , params: { invoiceId: this.invoiceId, task: 'copier' }})
      },
      async deleteInvoice(){
          if (!await this.confirm('Confirmez-vous cette action ?')) {
            return;
          }
          const response = await InvoiceService.delete(this.invoiceId);

          if(response.data.status == 'success') {
            this.$emit("deleteInvoice", this.invoiceId);
          }
      },
    }
  }
</script>
